import "@fontsource-variable/eb-garamond";
import "@fontsource-variable/montserrat";
import $ from "jquery";
import imagesLoaded from "imagesloaded";

import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import SponsorsSlider from "./components/sponsors-slider";
import PressSlider from "./components/press-slider";
import LogosSlider from "./components/logos-slider";
import LogosSliderDesktop from "./components/logos-slider-desktop";
import TerritoriesSlider from "./components/territory-slider";
import PortalPageSlider from "./components/portal-page-slider";
import CookiesConsent from "./components/cookies-consent";
import { AccordionDef } from "./components/accordion";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";
import RatingsSlider from "./components/ratings-slider";
import DeviceManager from "./utils/device-manager";
import GallerySlider from "./components/gallery-slider";
import MapHandler from "./components/MapHandler";
import "./components/gallery";
import {
  currentDisplayedForm,
  displayFormDeux,
} from "./components/displayForm";
import handleTerritoriesFilter, {
  handleClick,
  handlePagination,
  showPosts,
} from "./components/handleTerritoriesFilter";
import homePressHeight from "./components/homePressHeight";
import { GeneralAccordion } from "./components/generalAccordion";

// (function ($) {
// window.$ = $;

if (typeof markers !== "undefined" && typeof mapId !== "undefined") {
  MapHandler(markers, mapId);
}

$(function () {
  const bootstrapApp = () => {
    const $html = $("html");

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass("touch");

      if (DeviceManager.isIos()) {
        $html.addClass("ios");
      }
    } else {
      $html.addClass("no-touch");
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass("ie11");
    } else if (DeviceManager.isEdge()) {
      $html.addClass("edge");
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($(".language-selector"));
    const siteHeader = new SiteHeader($(".site-header"), 20);

    // Home slider component
    const $homesSliders = $(".homepage-slider");
    if ($homesSliders.length) {
      $homesSliders.each(function (index, el) {
        const homeSlider = new HomeSlider($(el));
      });
    }

    // Gallery slider component
    const $gallerySliders = $(".section-gallery__images");
    if ($gallerySliders.length) {
      $gallerySliders.each(function (index, el) {
        const gallerySliders = new GallerySlider($(el));
      });
    }

    // Ratings slider component
    const $homeRatingsSlider = $(".home-rating-slider");
    if ($homeRatingsSlider.length) {
      $homeRatingsSlider.each(function (index, el) {
        const homeRatingsSlider = new RatingsSlider($(el));
      });
    }

    // News slider component
    const $newsSliders = $(".news-list--slider");
    if ($newsSliders.length) {
      $newsSliders.each(function (index, el) {
        const newsSlider = new NewsSlider($(el));
      });
    }

    // Partners slider component
    const $partnersSliders = $(".partners-slider");
    if ($partnersSliders.length) {
      $partnersSliders.each(function (index, el) {
        const partnerSlider = new PartnersSlider($(el));
      });
    }

    // Sponsors slider component
    const $sponsorsSliders = $(".home-sponsor__list-slider");
    if ($sponsorsSliders.length) {
      $sponsorsSliders.each(function (index, el) {
        const sponsorSlider = new SponsorsSlider($(el));
      });
    }

    // Press slider component
    const $pressSliders = $(".home-press__slider");
    if ($pressSliders.length) {
      $pressSliders.each(function (index, el) {
        const pressSlider = new PressSlider($(el));
      });
    }

    // Press slider component
    const $logosSliders = $(".home-press__logos--mobile");
    if ($logosSliders.length) {
      $logosSliders.each(function (index, el) {
        const logosSlider = new LogosSlider($(el));
      });
    }

    // Press slider component - DESKTOP
    const $logosSlidersDesktop = $(".home-press__logos--desktop");
    if ($logosSlidersDesktop.length) {
      $logosSlidersDesktop.each(function (index, el) {
        const logosSliderDesktop = new LogosSliderDesktop($(el));
      });
    }

    // Territories slider component
    const $territoriesSliders = $(".territory-carousel");
    if ($territoriesSliders.length) {
      $territoriesSliders.each(function (index, el) {
        const territoriesSlider = new TerritoriesSlider($(el));
      });
    }

    // Reviews slider component
    const $reviewsSlider = $(".reviews-slider");
    if ($reviewsSlider.length) {
      $reviewsSlider.each(function (index, el) {
        const reviewsSlider = new ReviewsSlider($(el));
      });
    }

    // BU Product slider component
    const $buProductSlider = $(".bu-products-slider");
    if ($buProductSlider.length) {
      $buProductSlider.each(function (index, el) {
        const buProductSlider = new BUProductSlider($(el));
      });
    }

    // Portal page slider component
    const $portalPageSliders = $(".portal-page__header-slider");
    if ($portalPageSliders.length) {
      $portalPageSliders.each(function (index, el) {
        const portalPageSlider = new PortalPageSlider($(el));
      });
    }

    // Newsletter form component
    const $newsletterFormElements = $(
      ".footer-block.footer-block--newsletter-style"
    );
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Cookie consent
    if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
      // Tarteaucitron cookie settings
      let tarteaucitronLang = "fr";

      const cookiesConsent = new CookiesConsent(tarteaucitronLang);
    }

    // Scroll in view component
    const $scrollInViewElements = $(".scroll-in-view");
    if ($scrollInViewElements.length) {
      $scrollInViewElements.imagesLoaded(function () {
        const scrollInView = new ScrollInView($scrollInViewElements);
      });
    }
  };

  bootstrapApp();
  instanciateComponents();
});

// })(jQuery);

const menuToggler = document.querySelector(
  ".site-header__menu-toggler.menu-toggler"
);
const menuNav = document.querySelector(".site-header__navs");

if (menuToggler && menuNav) {
  menuToggler.addEventListener("click", () => {
    menuToggler.classList.toggle("menu-toggler--opened");
    menuNav.classList.toggle("menu--opened");
  });
}

const pageSubmitRestaurant = document.querySelector(
  ".page-template-template-cinq"
);

if (pageSubmitRestaurant) {
  const conditions = document.querySelector(".conditions");
  const formFooter = document.querySelector(".gform_footer");

  formFooter.append(conditions);
}

const subMenuListContainer = document.querySelectorAll(
  "#secondary-menu .menu-item-has-children"
);
const addForm = document.querySelector("#add-form");
const removeForm = document.querySelector("#remove-form");
const inputNumber = document.querySelector("#input_5_16");
const unitForms = document.querySelectorAll(".unit-form");
const selectForm = document.querySelectorAll(".select-form input.large");
const charteContainer = document.querySelector(".gfield_consent_description");
let removedForm = [];
const windowWidth = window.innerWidth;

if (subMenuListContainer) {
  subMenuListContainer.forEach((elem) => {
    const link = elem.querySelector('a[href="#"]');
    const menu = elem.querySelector(".sub-menu");

    if (windowWidth < 1024) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        menu.classList.toggle("sub-menu--opened");
      });
    } else {
      link.addEventListener("mouseover", () => {
        menu.classList.add("sub-menu--opened");
      });

      menu.addEventListener("mouseleave", () => {
        menu.classList.remove("sub-menu--opened");
      });
    }
  });
}

if (charteContainer) {
  charteContainer.innerHTML = "";
  const link = document.createElement("a");
  const currentFullUrl = window.location.href;
  const currentUrl = window.location.origin;
  link.classList.add("button");
  link.classList.add("button--primary");
  link.textContent = "Télécharger la charte";
  if (currentFullUrl.includes("localhost")) {
    link.href =
      "http://localhost/legrandrepas/wp-content/uploads/2024/04/charte-le-grand-repas.pdf";
  } else if (currentFullUrl.includes("dev3")) {
    link.href =
      "http://legrandrepas.fr.dev3.tribu-and-co.com/wp-content/uploads/2024/04/charte-le-grand-repas.pdf";
  } else {
    link.href = `${currentUrl}/wp-content/uploads/2025/07/charte_le-grand-repas_2025.pdf`;
  }
  link.target = "_blank";
  charteContainer.appendChild(link);
}

if (addForm && unitForms) {
  unitForms.forEach((form) => {
    form.style.display = "none";
  });
  if (Number(selectForm[0].value) === 1) {
    unitForms[0].style.display = "grid";
  }

  unitForms.forEach((form) => {
    const attribute = form.getAttribute("data-form");
    const removeBtn = form.querySelector(".heading-form span");

    if (removeBtn) {
      removeBtn.addEventListener("click", (e) => {
        removedForm.push(Number(attribute));
        selectForm[attribute - 1].value = 0;
        selectForm[attribute - 1].dispatchEvent(new Event("change", e));
        form.style.display = "none";
        checkForm();
      });
    }
  });
  const checkForm = () => {
    let showBtn = 0;
    if (removedForm.length === 0) {
      selectForm.forEach((select) => {
        if (Number(select.value) === 1) {
          showBtn += 1;
        }
      });

      if (showBtn === 5) {
        addForm.style.display = "none";
      } else {
        addForm.style.display = "flex";
      }
    } else {
      addForm.style.display = "flex";
    }
  };

  addForm.addEventListener("click", (e) => {
    e.preventDefault();
    if (removedForm.length === 0) {
      const displayedForm = currentDisplayedForm(unitForms);
      if (
        Number(selectForm[displayedForm - 1].value) === 1 &&
        displayedForm < 5
      ) {
        unitForms[displayedForm - 1].classList.add("collapsed");
        selectForm[displayedForm].value = 1;
        selectForm[displayedForm].dispatchEvent(new Event("change", e));
        displayFormDeux(unitForms, displayedForm);
        window.scrollTo(0, unitForms[displayedForm].offsetTop);
      }
      checkForm();
      return;
    }

    const removed = removedForm.shift();
    selectForm[removed - 1].value = 1;
    selectForm[removed - 1].dispatchEvent(new Event("change", e));
    displayFormDeux(unitForms, removed - 1);
    checkForm();
  });

  unitForms.forEach((element) => {
    new AccordionDef(element);
  });
}

const homePressWrapper = document.querySelectorAll(".home-press__wrapper");

if (homePressWrapper.length) {
  homePressHeight(homePressWrapper);
}

const blogPage = document.querySelector(".blog");

if (blogPage) {
  const filtersSelector = blogPage.querySelector("#territories");
  const posts = blogPage.querySelectorAll(".news-list .home-press__wrapper");

  const pagination = blogPage.querySelector(".pagination");

  showPosts(posts);

  if (posts.length < 12) {
    pagination.style.display = "none";
  } else {
    handlePagination(posts);
  }

  filtersSelector?.addEventListener("change", (e) => {
    handleTerritoriesFilter(e.target.value, posts);
  });
}

$("#sponsor-read-more").click(function () {
  $(".home-sponsor__featured-chef-text").removeClass("text--shortened");
  $(".home-sponsor__featured-chef-text").addClass("text--opened");
});

$("#sponsor-read-less").click(function () {
  $(".home-sponsor__featured-chef-text").removeClass("text--opened");
  $(".home-sponsor__featured-chef-text").addClass("text--shortened");
});

var sponsorPresentation = $(".territory-sponsor__presentation-text");

if (sponsorPresentation.length > 0) {
  var sponsorText = sponsorPresentation.text();
  var sponsorTextLength = sponsorText.length;

  if (sponsorTextLength > 500) {}

  $(".territory-sponsor__presentation-footer .button--more").click(function () {
    $(this).parent().prev().removeClass("text--shortened");
    $(this).parent().prev().addClass("text--opened");
    console.log("Show more !");
  // $(".territory-sponsor__presentation-text").removeClass("text--shortened");
    // $(".territory-sponsor__presentation-text").addClass("text--opened");
  });
  
  $(".territory-sponsor__presentation-footer .button--less").click(function () {
    $(this).parent().prev().removeClass("text--opened");
    $(this).parent().prev().addClass("text--shortened");
    console.log("Show less !");
  // $(".territory-sponsor__presentation-text").removeClass("text--opened");
    // $(".territory-sponsor__presentation-text").addClass("text--shortened");
  });

}

$(".home-ambassadors #read-more").click(function () {
  $(this)
    .parents(".home-ambassadors__list-item-details")
    .removeClass("text--shortened");
  $(this)
    .parents(".home-ambassadors__list-item-details")
    .addClass("text--opened");
});

$(".home-ambassadors #read-less").click(function () {
  $(this)
    .parents(".home-ambassadors__list-item-details")
    .removeClass("text--opened");
  $(this)
    .parents(".home-ambassadors__list-item-details")
    .addClass("text--shortened");
});

var territoryPresentation = $(".territory-presentation__text-content");

if (territoryPresentation.length > 0) {
  var presentationText = territoryPresentation.text();
  var presentationTextLength = presentationText.length;

  if (presentationTextLength > 1100) {
    territoryPresentation.addClass("text--shortened");
  }

  $("#presentation-read-more").click(function () {
    $(this)
      .parents(".territory-presentation__text-content")
      .removeClass("text--shortened");
    $(this)
      .parents(".territory-presentation__text-content")
      .addClass("text--opened");
  });

  $("#presentation-read-less").click(function () {
    $(this)
      .parents(".territory-presentation__text-content")
      .removeClass("text--opened");
    $(this)
      .parents(".territory-presentation__text-content")
      .addClass("text--shortened");
  });
}

$(".recipe__title").click(function () {
  $(this).parent().toggleClass("recipe--opened");
});

$(".map-marker").click(function () {
  var openedMarkers = $(".map-marker.is-opened");
  var openedTooltips = $(".tooltip.is-opened");

  if (openedMarkers.length) {
    openedMarkers.removeClass("is-opened");
  }
  if (openedTooltips.length) {
    openedTooltips.removeClass("is-opened");
  }

  $(this).toggleClass("is-opened");
  $(this).next().toggleClass("is-opened");
});

const accordionSection = document.querySelectorAll(".accordion-section");

if (accordionSection.length) {
  accordionSection.forEach((el) => {
    el.querySelectorAll("details").forEach((details) => {
      new GeneralAccordion(details);
    });
  });
}
